<app-einhorn-impressum *ngIf="branding === 'einhornkraut'"></app-einhorn-impressum>
<app-telecura-impressum *ngIf="branding !== 'einhornkraut'"></app-telecura-impressum>